
/**
 * 提供代理的浏览器window对象
 * 
 * 应用中获取的所有的window对象都应从这里获取，便于进行AOP扩展
 * 
 */
module.exports = window;


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/support/window.js
// module id = 2
// module chunks = 0